/**
 * @generated SignedSource<<e48c48ead86016dc2200a4fd770540ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubSearchFieldsEnum = "AuthorId" | "Content" | "Created" | "Description" | "Group" | "Id" | "Metadata" | "Modified" | "PostOrder" | "Slug" | "Status" | "StatusSettings" | "Template" | "Title" | "UserId" | "UserMeta";
export type HubTemplateEnum = "HOME_LANDING_PAGE" | "HUB_TEMPLATE_03" | "SALES_LANDING_PAGE";
export type OrderEnum = "ASC" | "DESC";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type RelationEnum = "AND" | "OR";
export type RootQueryToHubConnectionWhereArgs = {
  authorId?: string | null | undefined;
  authorIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  authorIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  content?: string | null | undefined;
  createdDateQuery?: DateQueryInput | null | undefined;
  description?: string | null | undefined;
  group?: string | null | undefined;
  groupIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  groupNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  id?: string | null | undefined;
  idIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  idNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  modifiedDateQuery?: DateQueryInput | null | undefined;
  order?: OrderEnum | null | undefined;
  orderBy?: ReadonlyArray<HubSearchFieldsEnum | null | undefined> | null | undefined;
  postOrder?: number | null | undefined;
  search?: string | null | undefined;
  searchFields?: ReadonlyArray<HubSearchFieldsEnum | null | undefined> | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  statusNotIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  template?: HubTemplateEnum | null | undefined;
  templateIn?: ReadonlyArray<HubTemplateEnum | null | undefined> | null | undefined;
  templateNotIn?: ReadonlyArray<HubTemplateEnum | null | undefined> | null | undefined;
  title?: string | null | undefined;
  userId?: string | null | undefined;
  userIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  userIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type Hubs_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToHubConnectionWhereArgs | null | undefined;
};
export type Hubs_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Hubs_Pagination_Fragment">;
};
export type Hubs_Query = {
  response: Hubs_Query$data;
  variables: Hubs_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": 24,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": {
    "search": null,
    "statusIn": [
      "PUBLISH",
      "HIDDEN",
      "DRAFT",
      "PENDING"
    ]
  },
  "kind": "LocalArgument",
  "name": "where"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StateWhenApproved",
      "kind": "LinkedField",
      "name": "stateWhenApproved",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v10/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v7/*: any*/),
  (v4/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "featuredImageFile",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featuredImageLink",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "contentFile",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLink",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentMediaName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentMediaType",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Form",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v26/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitSuccessText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingConsent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v28 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Hubs_Query",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "Hubs_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "Hubs_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RootQueryToHubConnection",
        "kind": "LinkedField",
        "name": "hubs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToHubConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "template",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "group",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postOrder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NodeWizAuthorToUserConnectionEdge",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubUserMeta",
                    "kind": "LinkedField",
                    "name": "userMeta",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "role",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v7/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubMetadataDesign",
                        "kind": "LinkedField",
                        "name": "design",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "borderRadius",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubMetadataShareIcons",
                        "kind": "LinkedField",
                        "name": "shareIcons",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubMetadataNavMeta",
                        "kind": "LinkedField",
                        "name": "navMeta",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "znglistId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Znglist",
                            "kind": "LinkedField",
                            "name": "znglist",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Znglist_Znglist",
                                "kind": "LinkedField",
                                "name": "znglist",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "znglyContents",
                                    "plural": true,
                                    "selections": [
                                      (v18/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ZnglyVideo_Znglycontent",
                                            "kind": "LinkedField",
                                            "name": "znglyContent",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ZnglyVideo",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v4/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "order": "ASC",
                          "orderBy": "PageOrder"
                        }
                      }
                    ],
                    "concreteType": "HubToConnectionHubToHpsConnection",
                    "kind": "LinkedField",
                    "name": "connectionHubToHps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubToConnectionHubToHpsConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConnectionHubToHp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pageId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pageOrder",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pageTitle",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pageIcon",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "where",
                                    "value": {
                                      "statusIn": [
                                        "PUBLISH",
                                        "DRAFT"
                                      ]
                                    }
                                  }
                                ],
                                "concreteType": "ConnectionHubToHpToHubPageConnectionEdge",
                                "kind": "LinkedField",
                                "name": "hubPage",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HubPage",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "HubPageToFormConnectionEdge",
                                        "kind": "LinkedField",
                                        "name": "form",
                                        "plural": false,
                                        "selections": (v27/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                              "order": "ASC",
                                              "orderBy": "CatalogOrder"
                                            }
                                          }
                                        ],
                                        "concreteType": "HubPageToConnectionHpToCsConnection",
                                        "kind": "LinkedField",
                                        "name": "connectionHpToCs",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "HubPageToConnectionHpToCsConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ConnectionHpToC",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "catalogId",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "catalogOrder",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ConnectionHpToCToZnglyVideoConnectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "catalog",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ZnglyVideo",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v4/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "NodeWithAuthorToUserConnectionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "author",
                                                            "plural": false,
                                                            "selections": (v13/*: any*/),
                                                            "storageKey": null
                                                          },
                                                          (v5/*: any*/),
                                                          (v6/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "link",
                                                            "storageKey": null
                                                          },
                                                          (v9/*: any*/),
                                                          (v12/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AiSearchResults",
                                                            "kind": "LinkedField",
                                                            "name": "searchResults",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Snippet",
                                                                "kind": "LinkedField",
                                                                "name": "snippets",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "snippet",
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ExtractiveAnswer",
                                                                "kind": "LinkedField",
                                                                "name": "extractiveAnswers",
                                                                "plural": true,
                                                                "selections": [
                                                                  (v26/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "pageNumber",
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ZnglyVideo_Znglycontent",
                                                            "kind": "LinkedField",
                                                            "name": "znglyContent",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "aiSummary",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "ctaLink",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "ctaName",
                                                                "storageKey": null
                                                              },
                                                              (v25/*: any*/),
                                                              (v23/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "contentEmbedHtml",
                                                                "storageKey": null
                                                              },
                                                              (v24/*: any*/),
                                                              (v22/*: any*/),
                                                              (v21/*: any*/),
                                                              (v20/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "shortText",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "htmlDesc",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "form",
                                                                "plural": false,
                                                                "selections": (v27/*: any*/),
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v4/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "connectionHpToCs(first:100,where:{\"order\":\"ASC\",\"orderBy\":\"CatalogOrder\"})"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "hubPage(where:{\"statusIn\":[\"PUBLISH\",\"DRAFT\"]})"
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "connectionHubToHps(where:{\"order\":\"ASC\",\"orderBy\":\"PageOrder\"})"
                  },
                  (v28/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToHubConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "Hubs_Pagination_Fragment_Connection_hubs",
        "kind": "LinkedHandle",
        "name": "hubs"
      }
    ]
  },
  "params": {
    "cacheID": "aeb29cff81699d7fb290d46809e1ea44",
    "id": null,
    "metadata": {},
    "name": "Hubs_Query",
    "operationKind": "query",
    "text": "query Hubs_Query(\n  $first: Int = 24\n  $after: String = null\n  $where: RootQueryToHubConnectionWhereArgs = {statusIn: [PUBLISH, HIDDEN, DRAFT, PENDING], search: null}\n) {\n  ...Hubs_Pagination_Fragment_3sueo6\n}\n\nfragment Hubs_Pagination_Fragment_3sueo6 on RootQuery {\n  hubs(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        id\n        databaseId\n        title\n        description\n        slug\n        status\n        statusSettings {\n          status\n          uiPermission {\n            type\n          }\n          stateWhenApproved {\n            status\n            uiPermission {\n              type\n            }\n          }\n          approved {\n            id\n            timestamp\n            user {\n              name\n              id\n            }\n          }\n        }\n        created\n        modified\n        template\n        group\n        postOrder\n        author {\n          node {\n            id\n            name\n            username\n            slug\n          }\n        }\n        userId\n        userMeta {\n          name\n          description\n          role\n          imageId\n          image {\n            id\n            mediaItemUrl\n            mimeType\n            mediaDetails {\n              sizes {\n                sourceUrl\n                name\n              }\n            }\n            description\n            title\n          }\n        }\n        metadata {\n          design {\n            borderRadius\n          }\n          shareIcons {\n            icon\n            title\n            url\n          }\n          navMeta {\n            icon\n            title\n            znglistId\n            znglist {\n              id\n              title\n              znglist {\n                znglyContents {\n                  __typename\n                  ... on ZnglyVideo {\n                    id\n                    znglyContent {\n                      featuredImageFile {\n                        mediaItemUrl\n                        mimeType\n                        mediaDetails {\n                          sizes {\n                            sourceUrl\n                            name\n                          }\n                        }\n                        description\n                        id\n                      }\n                      featuredImageLink\n                      contentFile {\n                        mediaItemUrl\n                        mimeType\n                        mediaDetails {\n                          sizes {\n                            sourceUrl\n                            name\n                          }\n                        }\n                        description\n                        id\n                      }\n                      contentLink\n                      contentMediaName\n                      contentMediaType\n                    }\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n        connectionHubToHps(where: {order: ASC, orderBy: PageOrder}) {\n          edges {\n            node {\n              pageId\n              pageOrder\n              pageTitle\n              pageIcon\n              hubPage(where: {statusIn: [PUBLISH, DRAFT]}) {\n                node {\n                  id\n                  title\n                  description\n                  form {\n                    node {\n                      id\n                      title\n                      content\n                      schema\n                      uiSchema\n                      metadata {\n                        formStyle\n                        formTemplate\n                        cookieExpiration\n                        submitSuccessText\n                      }\n                      marketingConsent\n                      password\n                      imageUrl\n                    }\n                  }\n                  connectionHpToCs(first: 100, where: {order: ASC, orderBy: CatalogOrder}) {\n                    edges {\n                      node {\n                        catalogId\n                        catalogOrder\n                        catalog {\n                          node {\n                            id\n                            author {\n                              node {\n                                id\n                                name\n                                username\n                                slug\n                              }\n                            }\n                            databaseId\n                            title\n                            link\n                            status\n                            statusSettings {\n                              status\n                              uiPermission {\n                                type\n                              }\n                              stateWhenApproved {\n                                status\n                                uiPermission {\n                                  type\n                                }\n                              }\n                              approved {\n                                id\n                                timestamp\n                                user {\n                                  name\n                                  id\n                                }\n                              }\n                            }\n                            searchResults {\n                              snippets {\n                                snippet\n                              }\n                              extractiveAnswers {\n                                content\n                                pageNumber\n                              }\n                            }\n                            znglyContent {\n                              aiSummary\n                              ctaLink\n                              ctaName\n                              contentMediaType\n                              contentLink\n                              contentEmbedHtml\n                              contentMediaName\n                              contentFile {\n                                mediaItemUrl\n                                mimeType\n                                mediaDetails {\n                                  sizes {\n                                    sourceUrl\n                                    name\n                                  }\n                                }\n                                description\n                                id\n                              }\n                              featuredImageLink\n                              featuredImageFile {\n                                mediaItemUrl\n                                mimeType\n                                mediaDetails {\n                                  sizes {\n                                    sourceUrl\n                                    name\n                                  }\n                                }\n                                description\n                                id\n                              }\n                              shortText\n                              htmlDesc\n                              form {\n                                node {\n                                  id\n                                  title\n                                  content\n                                  schema\n                                  uiSchema\n                                  metadata {\n                                    formStyle\n                                    formTemplate\n                                    cookieExpiration\n                                    submitSuccessText\n                                  }\n                                  marketingConsent\n                                  password\n                                  imageUrl\n                                }\n                              }\n                            }\n                          }\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7dfc3027fb1ba515d680666452cf2c8b";

export default node;
